<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>物品采购单&nbsp;&nbsp;说明:</h5><br>
				<span>1、模式一:只录入明细,当作每次入库单的模板。</span><br>
				<span>2、模式二:录入明细后并且上传相关发票票据,可以提交到财务核对步骤报销费用,同时也可当作每次入库单的模板。</span><br>
				<span class="red">3、查询关键字:业务单号、仓库名称、变更日期、车队、物品编号、物品名称</span><br>

			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="pre_base_button">
				<button @click="edit_mode">引入模板</button>
			</template> -->

		</pre-base>
		<!-- 
		<editmode-tan ref="itemmode"></editmode-tan> -->

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "store_buy",
					"title": "采购单",
					"isTwo": "1",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_store_car_storebuy',
					"upd_action": 'exp15_store_car_storebuy',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "1",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": 'exp_store_car_storebuy_d',
					"d_upd_action": '_store_car_d_storebuy',
					"file_action": 'store_buy',
					"p1": 'store',
					"p2": 'buy',
					"p3": '',
					"parm_sel": [{
							"name": "系统编号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "仓库名称",
							"val": "",
							"key": "from_store",
							"type": "select",
							"class": "long2",
							"sel_action": "_base_storecar",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "变更日期",
							"val": "",
							"key": "out_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "车队",
							"val": "",
							"key": "team",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_teamname",
							"sel_name": ""
						},
						{
							"name": "物品名称",
							"val": "",
							"key": "item_name",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "物品编号",
							"val": "",
							"key": "item_no",
							"type": "date",
							"class": "long1"
						}
					],
					"parm": [{
							"name": "系统编号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "仓库名称",
							"val": "",
							"key": "in_store",
							"type": "select",
							"class": "long2",
							"sel_action": "_base_storecar",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "采购日期",
							"val": "",
							"key": "in_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "总金额",
							"val": "",
							"key": "amount",
							"type": "number",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "2"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "引入模板",
							"val": "",
							"key": "item_mode",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_itemmode",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						}
					],
					"parm_th": [{
							"name": "序号"
						}, {
							"name": "单号"
						},
						{
							"name": "仓库名称"
						},
						{
							"name": "采购日期"
						},
						{
							"name": "总金额"
						},
						{
							"name": "备注"
						},
						{
							"name": "明细"
						},
						{
							"name": "附件"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "路径1"
						},
						{
							"name": "路径2"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [
						{
								"name": "业务单号",
								"val": "",
								"key": "sheet_no",
								"type": "none",
								"class": "long1",
								"p": "1",
								"w": "0",
							},
							{
								"name": "物品编码",
								"val": "",
								"key": "item_no",
								"type": "text",
								"class": "long1",
								"p": "1",
								"w": "1",
							},
							{
								"name": "物品数量",
								"val": "",
								"key": "qty",
								"type": "number",
								"class": "long1",
								"p": "1",
								"w": "1",
							},
							{
								"name": "物品价格",
								"val": "",
								"key": "price",
								"type": "number",
								"class": "long1",
								"p": "1",
								"w": "1",
							},
							{
								"name": "来自",
								"val": "",
								"key": "f_name",
								"type": "select",
								"class": "long1",
								"sel_action": "_base_itemfrom",
								"sel_name": "",
								"p": "1",
								"w": "0",
							},
							{
								"name": "备注",
								"val": "",
								"key": "note",
								"type": "text",
								"p": "1",
								"w": "0"
							}
					],
					"d_name": [
						{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "物品编号"
						},
						{
							"name": "名称"
						},
						{
							"name": "规格"
						},
						{
							"name": "单位"
						},
						{
							"name": "数量"
						},
						{
							"name": "单价"
						},
						{
							"name": "来自哪里"
						},
						{
							"name": "备注"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					]

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			// edit_mode: function() {

			// 	this.$refs.itemmode.showpop();
			// },



		}
	};
</script>
<style>
</style>
